export const preSaleTexts = {
  title: 'PreviousYears.presale.title',
  subtitle: '',
  buttonLabel: 'PreviousYears.presale.button',
  disclaimer: 'PreviousYears.presale.disclaimer',
  type: 'preSale',
};
